if(!customElements.get('custom-video-with-text')){
    class CustomVideoWithText extends HTMLElement{
        constructor(){
            super();

            this.init();
        }

        init(){
            this.video = this.querySelector('video');
            if(typeof this.video == 'undefined') return;
            this.video.addEventListener('loadeddata', (e) => {
                this.video.classList.add('loaded');
            })
            if (this.video.readyState >= 2) {
                this.video.classList.add('loaded');
            }
        }
    }

    customElements.define('custom-video-with-text', CustomVideoWithText);
}